import React from "react";
import Routes from "./Routes";
import { AuthProvider } from "./lib/AuthContext";
import { SpeedInsights } from "@vercel/speed-insights/react"
import { Analytics } from "@vercel/analytics/react"
import MiniAppWrapper from "./components/MiniAppWrapper";
import ChatAgent from "./components/ChatAgent";

function App() {
  return (
    <AuthProvider>
      <SpeedInsights />
      <MiniAppWrapper>
        <Routes />
        <ChatAgent />
      </MiniAppWrapper>
      <Analytics />
    </AuthProvider>
  );
}

export default App;
